import { Component, h, Prop } from '@stencil/core';
import { ComponentView } from '../../../types/types';

@Component({
  tag: 'rentware-variation-selection-item-template',
  styleUrl: 'style.sass',
  shadow: true,
})
export class RentwareVariationSelectionItemTemplate {
  @Prop() variation;
  @Prop() waitingArticles;
  @Prop() itemInCart;
  @Prop() variationsInCart;
  @Prop() handleChangeAmount;
  @Prop() selectedText;
  @Prop() unselectedText;
  @Prop() selectedVariationId: string;
  @Prop() isWaiting: boolean;
  @Prop() changeSelectedVariation: (string) => void;

  get selectedVariation() {
    return this.variation?.items?.find(item => item.id === this.selectedVariationId);
  }

  get selectedVariationInCart() {
    return this.variationsInCart?.find(item => item.id === this.selectedVariationId);
  }

  get controlValues() {
    return {
      disabled: this.waitingArticles?.includes(this.selectedVariationId) || this.isWaiting,
      id: this.selectedVariationId,
      minAmount: 1,
      maxAmount: (this.selectedVariation.quantityInCart || 0) + this.selectedVariation.quantity,
      itemAmount: this.selectedVariation.quantityInCart || 0,
      text: this.variationSelectedText,
      changeAmountCallback: (newAmount, oldAmount) => this.handleChangeAmount(this.selectedVariationId, this.itemInCart?.id, newAmount, oldAmount),
      deleteArticleCallback: () =>
        this.handleChangeAmount(this.selectedVariationId, this.itemInCart?.id, this.selectedVariation.quantityInCart || 0, this.selectedVariation.quantityInCart || 0),
    };
  }

  get variationSelectedText() {
    return (!!this.selectedVariationInCart && this.selectedText) || this.unselectedText;
  }

  get options() {
    return this.variation?.items.map(item => {
      return {
        label: item.name,
        value: item.id,
      };
    });
  }

  render() {
    return (
      <div class="ItemContainer">
        <rentware-select
          label={this.variation.name}
          value={this.selectedVariationId}
          onValueChange={e => this.changeSelectedVariation(e.detail.value)}
          options={this.options}
          disabled={this.isWaiting}
        />

        <rentware-spacer size="M" />

        <rentware-amount-control view={ComponentView.Booking} controlValues={this.controlValues} />
      </div>
    );
  }
}
